import { useReveal } from "@/hooks/useReveal";

const PARAGRAPHS = [
  "We're the Cherechians, the same family that started trading fabric in 1967. Two generations later, Cherechian Trading Co is still family-owned and still run from the warehouse floor, even if it isn't the same floor we started on.",
  "Over the years we watched the industry chase cheaper goods overseas. We went the other way. Today we're among the last distributors of American-made spandex and specialty stretch, supplying small and mid-size manufacturers and resellers who need quality they can count on.",
  "Going domestic never meant closing the door. We work with international buyers every day. Online we go by Spandex American Fabrics; on the phone, on the floor, and on your invoice, we're the same Cherechian Trading Co we've always been.",
];

export const AboutSection = () => {
  const [ref, shown] = useReveal({ threshold: 0.2 });
  return (
    <section id="about" data-testid="section-about" className="seam-top bg-mist">
      <div
        ref={ref}
        className={`mx-auto max-w-[1200px] px-5 py-[120px] transition-[opacity,transform] duration-[600ms] ease-out md:px-7 lg:px-10 ${
          shown ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
        }`}
      >
        <div className="mx-auto max-w-[640px]">
          <p className="eyebrow text-xs text-ember">Our Story · Cherechian Trading Co</p>
          <h2 className="font-display mt-5 text-3xl font-extrabold leading-[1.08] text-charcoal md:text-[40px]">
            Sixty years of American fabric.
          </h2>
          <div className="mt-8 flex flex-col gap-6">
            {PARAGRAPHS.map((text) => (
              <p
                key={text.slice(0, 24)}
                className="font-inter text-base leading-[1.7] text-charcoal/80"
              >
                {text}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
